"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bookHealthPackage = bookHealthPackage;
exports.bookPackage = bookPackage;
exports.cancelPackage = cancelPackage;
exports.default = packageWatchers;
exports.getAllActivePackages = getAllActivePackages;
exports.getBookedPackageDetailsAPI = getBookedPackageDetailsAPI;
exports.getBookedPackageListAPI = getBookedPackageListAPI;
exports.getCmsPackageListAPI = getCmsPackageListAPI;
exports.getPackageAmountListAPI = getPackageAmountListAPI;
exports.getPackageCliniclistAPI = getPackageCliniclistAPI;
exports.getPackageDetailsAPI = getPackageDetailsAPI;
exports.getPackageListAPI = getPackageListAPI;
exports.getPackageStaticContent = getPackageStaticContent;
exports.getRelatedPackages = getRelatedPackages;
exports.getfacilityPackageAPI = getfacilityPackageAPI;
var _effects = require("redux-saga/effects");
var api = _interopRequireWildcard(require("../api/api"));
var actions = _interopRequireWildcard(require("./actions"));
var _sagas = require("../../../astercore/auth/login/redux/sagas");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function* getfacilityPackageAPI(params) {
  try {
    const {
      requestParam
    } = params.data;
    yield (0, _effects.put)(actions.GET_FACILITY_PACKAGES_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getFacilityPackage, requestParam, tokenData);
    yield (0, _effects.put)(actions.GET_FACILITY_PACKAGES_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.GET_FACILITY_PACKAGES_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getPackageListAPI(params) {
  try {
    const {
      requestParam
    } = params.data;
    yield (0, _effects.put)(actions.GET_PACKAGE_LIST_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getPackageList, requestParam, tokenData);
    yield (0, _effects.put)(actions.GET_PACKAGE_LIST_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PACKAGE_LIST_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getPackageDetailsAPI(params) {
  try {
    const {
      requestParam
    } = params.data;
    yield (0, _effects.put)(actions.GET_PACKAGE_DETAILS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getPackageDetails, requestParam, tokenData);
    yield (0, _effects.put)(actions.GET_PACKAGE_DETAILS_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PACKAGE_DETAILS_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getPackageCliniclistAPI(params) {
  try {
    const {
      requestParam
    } = params.data;
    yield (0, _effects.put)(actions.GET_PACKAGE_CLINICLIST_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getPackageClinicList, requestParam, tokenData);
    yield (0, _effects.put)(actions.GET_PACKAGE_CLINICLIST_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PACKAGE_CLINICLIST_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getBookedPackageListAPI(params) {
  try {
    const {
      requestParam
    } = params.data;
    yield (0, _effects.put)(actions.GET_BOOKED_PACKAGES_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getBookedPackageList, requestParam, tokenData);
    yield (0, _effects.put)(actions.GET_BOOKED_PACKAGES_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.GET_BOOKED_PACKAGES_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getBookedPackageDetailsAPI(params) {
  try {
    const {
      requestParam
    } = params.data;
    yield (0, _effects.put)(actions.GET_BOOKED_PACKAGED_DETAILS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getBookedPackageDetails, requestParam, tokenData);
    yield (0, _effects.put)(actions.GET_BOOKED_PACKAGED_DETAILS_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.GET_BOOKED_PACKAGED_DETAILS_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getPackageAmountListAPI(params) {
  try {
    const {
      requestParam
    } = params.data;
    yield (0, _effects.put)(actions.GET_PACKAGE_AMOUNT_LIST_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getPackageAmountList, requestParam, tokenData);
    yield (0, _effects.put)(actions.GET_PACKAGE_AMOUNT_LIST_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PACKAGE_AMOUNT_LIST_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* cancelPackage(params) {
  try {
    const {
      requestParam
    } = params.data;
    yield (0, _effects.put)(actions.CANCEL_PACKAGE_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.cancelPackage, requestParam, tokenData);
    yield (0, _effects.put)(actions.CANCEL_PACKAGE_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.CANCEL_PACKAGE_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* bookPackage(params) {
  try {
    const {
      requestParam
    } = params.data;
    yield (0, _effects.put)(actions.BOOK_PACKAGE_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.bookPackage, requestParam, tokenData);
    yield (0, _effects.put)(actions.BOOK_PACKAGE_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.BOOK_PACKAGE_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getCmsPackageListAPI(params) {
  try {
    const {
      requestParam
    } = params.data;
    yield (0, _effects.put)(actions.GET_CMS_PACKGE_LIST_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getCmsPackageList, requestParam, tokenData);
    yield (0, _effects.put)(actions.GET_CMS_PACKGE_LIST_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.GET_CMS_PACKGE_LIST_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* bookHealthPackage(params) {
  try {
    const {
      requestParam
    } = params.data;
    yield (0, _effects.put)(actions.BOOK_HEALTH_PACKAGE_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.bookHealthPackageApi, requestParam, tokenData);
    yield (0, _effects.put)(actions.BOOK_HEALTH_PACKAGE_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.BOOK_HEALTH_PACKAGE_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getPackageStaticContent(params) {
  try {
    const {
      requestParam
    } = params.data;
    yield (0, _effects.put)(actions.GET_PACKAGE_STATIC_CONTENT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getStaticContent, requestParam, tokenData);
    yield (0, _effects.put)(actions.GET_PACKAGE_STATIC_CONTENT_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PACKAGE_STATIC_CONTENT_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getRelatedPackages(params) {
  try {
    const {
      requestParam
    } = params.data;
    yield (0, _effects.put)(actions.GET_RELATED_PACKAGES_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getRelatedPackages, requestParam, tokenData);
    yield (0, _effects.put)(actions.GET_RELATED_PACKAGES_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.GET_RELATED_PACKAGES_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getAllActivePackages(params) {
  try {
    const {
      requestParam
    } = params.data;
    yield (0, _effects.put)(actions.GET_ALL_ACTIVE_PACKAGES_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getAllActivePackages, requestParam, tokenData);
    yield (0, _effects.put)(actions.GET_ALL_ACTIVE_PACKAGES_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.GET_ALL_ACTIVE_PACKAGES_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* packageWatchers() {
  yield (0, _effects.takeLatest)(actions.GET_FACILITY_PACKAGES, getfacilityPackageAPI);
  yield (0, _effects.takeLatest)(actions.GET_PACKAGES_LIST, getPackageListAPI);
  yield (0, _effects.takeLatest)(actions.GET_PACKAGE_DETAILS, getPackageDetailsAPI);
  yield (0, _effects.takeLatest)(actions.GET_PACKAGE_CLINICLIST, getPackageCliniclistAPI);
  yield (0, _effects.takeLatest)(actions.GET_BOOKED_PACKAGES, getBookedPackageListAPI);
  yield (0, _effects.takeLatest)(actions.GET_BOOKED_PACKAGE_DETAILS, getBookedPackageDetailsAPI);
  yield (0, _effects.takeLatest)(actions.GET_PACKAGE_AMOUNT_LIST, getPackageAmountListAPI);
  yield (0, _effects.takeLatest)(actions.CANCEL_PACKAGE, cancelPackage);
  yield (0, _effects.takeLatest)(actions.BOOK_PACKAGE, bookPackage);
  yield (0, _effects.takeLatest)(actions.GET_CMS_PACKGE_LIST, getCmsPackageListAPI);
  yield (0, _effects.takeLatest)(actions.BOOK_HEALTH_PACKAGE, bookHealthPackage);
  yield (0, _effects.takeLatest)(actions.GET_PACKAGE_STATIC_CONTENT, getPackageStaticContent);
  yield (0, _effects.takeLatest)(actions.GET_RELATED_PACKAGES, getRelatedPackages);
  yield (0, _effects.takeLatest)(actions.GET_ALL_ACTIVE_PACKAGES, getAllActivePackages);
}